import { CheckCircle2 } from '@griply/assets';
import { COMPLETED_LOOKBACK_DAYS } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from 'shared/components/ui/empty-state';

export const CompletedEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={CheckCircle2}
      title={t('completed.empty.message', { count: COMPLETED_LOOKBACK_DAYS })}
    />
  );
};
